import http from 'axios'
import config from 'src/config'

export const getLocation = address =>
  http({
    url: 'https://maps.googleapis.com/maps/api/geocode/json',
    method: 'GET',
    params: {
      key: 'AIzaSyD9e84ytixqsGbHS1e9Sj4AFcBgVt_14UQ',
      address,
      sensor: false,
      components: 'country:Australia',
    },
    headers: {
      Authorization: null,
    },
  }).then(({ data }) =>
    data.results.map(item => ({
      name: item.formatted_address,
      geo: item.geometry.location,
      components: item.address_components,
    }))
  )

const alphaNumberMap = {
  a: 2,
  b: 2,
  c: 2,
  d: 3,
  e: 3,
  f: 3,
  g: 4,
  h: 4,
  i: 4,
  j: 5,
  k: 5,
  l: 5,
  m: 6,
  n: 6,
  o: 6,
  p: 7,
  q: 7,
  r: 7,
  s: 7,
  t: 8,
  u: 8,
  v: 8,
  w: 9,
  x: 9,
  y: 9,
  z: 9,
}

const getNumberQuery = stringQuery =>
  stringQuery
    .split('')
    .map(letter => alphaNumberMap[letter] || letter)
    .join('')

const transformNumber = (numberType, numberQuery, stringQuery, number, digits = 6) =>
  `${numberType}${number.substr(number.length - digits).replace(numberQuery, stringQuery)}`

const remove1300or1800 = (numberType, stringQuery) =>
  numberType === '1300' ? stringQuery.replace(/^(1300)/, '') : stringQuery.replace(/^(1800)/, '')

export const getNumber = async (numberType, stringQuery) => {
  const query = remove1300or1800(numberType, stringQuery)
  if (query && query.length > 0) {
    return http({
      url: `api/v1/numbers/${numberType}/premium`,
      method: 'GET',
      params: {
        query,
      },
    }).then(({ data }) => {
      const isAllNumbers = /^\d+$/.test(query)
      const stringQueryTransformed = query.toUpperCase()
      const numberQuery = getNumberQuery(query.toLowerCase())
      return data.map(({ number, monthlyCharge }) => {
        const numberWithLetters = transformNumber(
          numberType,
          numberQuery,
          stringQueryTransformed,
          number
        )
        return {
          name: isAllNumbers ? `${number}` : `${numberWithLetters} (${number})`,
          value: number,
          tag: `$${monthlyCharge}/mth`,
          meta: {
            number,
            numberWithLetters: !isAllNumbers && numberWithLetters,
            premiumNumberMonthlyFee: monthlyCharge,
          },
        }
      })
    })
  }
  return []
}

export const getTwilioNumbers = async (country, numberType, stringQuery) => {
  if (stringQuery && stringQuery.length >= 2) {
    return http({
      url: `api/v1/twilio/numbers/search`,
      method: 'POST',
      data: {
        country,
        type: numberType,
        filter: {
          contains: stringQuery,
          voiceEnabled: true,
        },
      },
    }).then(({ data }) => {
      const isAllNumbers = /^\d+$/.test(stringQuery)
      const stringQueryTransformed = stringQuery.toUpperCase()
      const numberQuery = getNumberQuery(stringQuery.toLowerCase())

      return data.map(item => {
        const numberFormatted = item.friendlyName.substr(1).replace('61', '0')
        const numberWithLetters = transformNumber(
          '',
          numberQuery,
          stringQueryTransformed,
          numberFormatted,
          numberFormatted.length
        )

        return {
          name: isAllNumbers ? `${numberFormatted}` : `${numberWithLetters} (${numberFormatted})`,
          value: item.friendlyName.substr(1),
          tag: item.locality,
          meta: {
            number: numberFormatted,
            numberWithLetters: !isAllNumbers && numberWithLetters,
          },
        }
      })
    })
  }
  return []
}

let _token

// ugly workaround to have auth token for autosuggestion api calls
export const storeAuthToken = () => next => action => {
  if (
    action.type === 'AUTH/LOGIN_FULFILLED' &&
    action.payload &&
    action.payload.data &&
    action.payload.data.token
  ) {
    _token = action.payload.data.token
  }
  if (
    action.type === 'MERGE_INITIAL_STATE' &&
    action.payload &&
    action.payload.auth &&
    action.payload.auth.token
  ) {
    _token = action.payload.auth.token
  }
  return next(action)
}

export const getContact = async search => {
  if (search && search.length > 0) {
    return http({
      headers: {
        Authorization: `Bearer ${_token}`,
      },
      method: 'GET',
      url: `${config.api.main}/api/v1/contacts`,
      params: {
        filter: {
          search,
        },
      },
    }).then(({ data }) => {
      const contacts = data.results
      const suggestions = []

      // flatten phone numbers
      contacts.forEach(contact => {
        if (contact.phoneNumbers) {
          const name = [contact.firstName, contact.lastName].filter(n => n).join(' ') || 'Unknown'
          contact.phoneNumbers.forEach(phoneNumber =>
            suggestions.push({
              name: `${phoneNumber} - ${name}`,
              value: phoneNumber,
            })
          )
        }
      })
      return suggestions
    })
  }
  return []
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Autosuggest/Autosuggest.utils.js